module.exports = __webpack_public_path__ + "media/country_flags/as-21fceade.png";